import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useLocation, useNavigate } from "react-router-dom";

import { useSidebar } from "../../SidebarContext";
import { X } from "lucide-react";
import { decryptToken } from "../utils/getToken";
import { getDecryptedUserFromCookie } from "../utils/getCookie";
import { toast } from "react-toastify";

const safeParse = (value, fallback = "") => {
    if (!value) return fallback;

    try {
        let parsed = value;
        // keep parsing if it's still a stringified JSON
        while (typeof parsed === "string" &&
            (parsed.startsWith("{") || parsed.startsWith("[") || parsed.startsWith('"'))) {
            parsed = JSON.parse(parsed);
        }
        return parsed;
    } catch (err) {
        return fallback;
    }
};

const NewStaff = () => {
    const apiUrl = process.env.REACT_APP_LINK;

    const location = useLocation();
    const prefill = location.state || {};
    const navigate = useNavigate();
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    const token = decryptToken("accessToken") || ""
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        employeeId: "",   // ✅
        dob: "",
        gender: "",
        profilePic: null,
        address: "",
        phone: "",
        email: "",
        password: "",
        emergency_contact_phone: "",
        job_title: "",
        department: "",
        dof_joining: "",
        employ_status: "",
        report_manager: "",
        office_location: "",
        start_time: "",
        end_time: "",
        qualifications: "",
        prev_exp: "",
        skills: [],
        language_known: [],
        account_no: "",
        ifsc: "",   // ✅
        bank: "",   // ✅
        pfNo: "",   // ✅
        marital_status: "",
        hobbies_interest: [],
        weeklyHoliday: "",
    });
    const [preview, setPreview] = useState()
    const [department, setDepartment] = useState([])
    const [loading, setLoading] = useState(false);

    const daysOptions = [
        { value: "Sunday", label: "Sunday" },
        { value: "Monday", label: "Monday" },
        { value: "Tuesday", label: "Tuesday" },
        { value: "Wednesday", label: "Wednesday" },
        { value: "Thursday", label: "Thursday" },
        { value: "Friday", label: "Friday" },
        { value: "Saturday", label: "Saturday" },
    ];

    const handleChange = (selectedOptions) => {
        // Store only the values in formData
        const selectedDays = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
        setFormData(prev => ({ ...prev, weeklyHoliday: selectedDays }));
    };

    // Preselect values if already in formData
    const selectedValues = daysOptions.filter(option =>
        formData.weeklyHoliday.includes(option.value)
    );

    const fetchDepartment = async () => {
        try {
            const response = await fetch(`${apiUrl}/department`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
                // credentials: "include"
            })
            const res = await response.json();
            ;
            setDepartment(res || []);
        } catch (error) {
            console.error(error)
        }
    }

    useEffect(() => {
        if (prefill && Object.keys(prefill).length > 0) {
            const parsedSkills = safeParse(prefill.skills, []);
            const parsedLanguages = safeParse(prefill.language_known, []);
            const parsedHobbies = safeParse(prefill.hobbies_interest, []);
            const parsedWeeklyHoliday = safeParse(prefill.weekly_holiday, []);

            setSkills(parsedSkills);
            // setSkillInput(parsedSkills.join(", "));

            setlanguage_known(parsedLanguages);
            // setLanguageInput(parsedLanguages.join(", "));

            setHobbies(parsedHobbies);
            // setHobbyInput(parsedHobbies.join(", "));

            setFormData((prev) => ({
                ...prev,
                firstName: prefill.firstName || "",
                lastName: prefill.lastName || "",
                dob: prefill.dob || "",
                emergency_contact_phone: prefill.emergency_contact_phone || "",
                email: prefill.email || "",
                job_title: prefill.job_title || "",
                dof_joining: prefill.dof_joining
                    ? new Date(prefill.dof_joining).toISOString().split("T")[0]
                    : "",
                report_manager: prefill.report_manager || "",
                office_location: prefill.office_location || "",
                start_time: prefill.start_time || "",
                end_time: prefill.end_time || "",
                prev_exp: prefill.prev_exp || "",
                qualifications: prefill.qualifications || "",
                employ_status: prefill.employ_status || "",
                address: prefill.address || "",
                password: prefill.password || "",
                employeeId: prefill.emplyee_ID || "",
                gender: prefill.gender || "",
                department: prefill.department || "",
                phone: prefill.phone || "",
                account_no: prefill.account_no || "",
                ifsc: prefill.ifsc_code || "",
                bank: prefill.bank_name || "",
                pfNo: prefill.provident_fund_number || "",
                marital_status: prefill.marital_status || "",
                weeklyHoliday: parsedWeeklyHoliday || "",
            }));


        }
    }, [prefill]);

    useEffect(() => {
        if (prefill && prefill.profilePic) {
            // Normalize slashes for browser
            const normalized = prefill.profilePic.replace(/\\/g, "/");

            // Make sure API URL is prepended if it’s a relative path
            const fullUrl = normalized.startsWith("http")
                ? normalized
                : `${apiUrl}${normalized.startsWith("/") ? "" : "/"}${normalized}`;

            setPreview(fullUrl);
        }
    }, [prefill]);


    // console.log(preview)

    // For dynamic add
    const [skills, setSkills] = useState([]);
    const [skillInput, setSkillInput] = useState("");

    const [language_known, setlanguage_known] = useState([]);
    const [languageInput, setLanguageInput] = useState("");

    const [hobbies_interest, setHobbies] = useState([]);
    const [hobbyInput, setHobbyInput] = useState("");


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        setFormData((prev) => ({ ...prev, profilePic: e.target.files[0] }));
    };

    const handleSkillKeyDown = (e) => {
        if (e.key === "," || e.key === "Enter") {
            e.preventDefault();
            if (skillInput.trim() !== "") {
                setSkills([...skills, skillInput.trim()]);
                setSkillInput("");
            }
        }
    };

    const removeSkill = (index) => {
        setSkills(skills.filter((_, i) => i !== index));
    };

    const handleLanguageKeyDown = (e) => {
        if (e.key === "," || e.key === "Enter") {
            e.preventDefault();
            if (languageInput.trim() !== "") {
                setlanguage_known([...language_known, languageInput.trim()]);
                setLanguageInput("");
            }
        }
    };

    const removeLanguage = (index) => {
        setlanguage_known(language_known.filter((_, i) => i !== index));
    };

    const handleHobbyKeyDown = (e) => {
        if (e.key === "," || e.key === "Enter") {
            e.preventDefault();
            if (hobbyInput.trim() !== "") {
                setHobbies([...hobbies_interest, hobbyInput.trim()]);
                setHobbyInput("");
            }
        }
    };

    const removeHobbies = (index) => {
        setHobbies(hobbies_interest.filter((_, i) => i !== index));
    };



    const handleSubmit = async (e) => {
        e.preventDefault();

        // Combine last typed values
        const finalSkills = skillInput.trim() ? [...skills, skillInput.trim()] : skills;
        const finalLanguages = languageInput.trim() ? [...language_known, languageInput.trim()] : language_known;
        const finalHobbies = hobbyInput.trim() ? [...hobbies_interest, hobbyInput.trim()] : hobbies_interest;

        // Use FormData
        const formPayload = new FormData();

        formPayload.append("firstName", formData.firstName);
        formPayload.append("lastName", formData.lastName);
        formPayload.append("full_name", `${formData.firstName} ${formData.lastName}`.trim());
        formPayload.append("dob", formData.dob);
        formPayload.append("gender", formData.gender);
        formPayload.append("email", formData.email);
        formPayload.append("password", formData.password);
        formPayload.append("phone", formData.phone);
        formPayload.append("qualifications", formData.qualifications);
        formPayload.append("prev_exp", formData.prev_exp);
        formPayload.append("address", formData.address);
        formPayload.append("emergency_contact_phone", formData.emergency_contact_phone);
        formPayload.append("username", formData.email || formData.firstName);
        formPayload.append("emplyee_ID", formData.employeeId);
        formPayload.append("job_title", formData.job_title);
        formPayload.append("department", (formData.department));
        formPayload.append("dof_joining", formData.dof_joining);
        formPayload.append("employ_status", formData.employ_status);
        formPayload.append("report_manager", formData.report_manager);
        formPayload.append("office_location", formData.office_location);
        formPayload.append("start_time", formData.start_time);
        formPayload.append("end_time", formData.end_time);
        formPayload.append("account_no", formData.account_no);
        formPayload.append("ifsc_code", formData.ifsc);
        formPayload.append("bank_name", formData.bank);
        formPayload.append("provident_fund_number", formData.pfNo);
        formPayload.append("marital_status", formData.marital_status);
        formPayload.append("weekly_holiday", JSON.stringify(formData.weeklyHoliday || ""));
        formPayload.append("skills", JSON.stringify(finalSkills));
        formPayload.append("language_known", JSON.stringify(finalLanguages));
        formPayload.append("hobbies_interest", JSON.stringify(finalHobbies));
        formPayload.append("user_name", isLoggedIn.full_name);

        // Append image if exists
        if (formData.profilePic) {
            formPayload.append("profilePic", formData.profilePic); // formData.photo should be a File object
        }

        const method = prefill.id ? "PUT" : "POST";
        const url = prefill.id
            ? `${apiUrl}/staff/change/${formData.employeeId}`
            : `${apiUrl}/staff/admin1997`;
        setLoading(true);
        try {
            const res = await fetch(url, {
                method,
                headers: {
                    "Authorization": `Bearer ${token}`, // Do NOT set Content-Type, browser will set it
                },
                body: formPayload,
            });

            const data = await res.json();
            console.log(data);

            if (res.ok) {
                toast.success(prefill.id ? "Staff updated successfully" : "Staff created successfully");
                navigate('/team-directory');
            } else {
                toast.error(`${data.message}`);
            }
        } catch (error) {
            toast.error(`${error.message}`);
        } finally {
            setLoading(false);
        }
    };



    useEffect(() => {
        fetchDepartment();
    }, [])



    return (
        <>
            <form className="oms-modal-form" onSubmit={handleSubmit}>
                {/* ---------- Basic Information ---------- */}
                <h3 className="text-xl sm:text-2xl md:text-3xl font-semibold text-gray-800 border-b-2 border-blue-500 inline-block pb-1 tracking-wide">Basic Information</h3>
                <div className="oms-form-flex">
                    <div className="oms-form-group">
                        <label className="oms-form-label">First Name</label>
                        <input
                            type="text"
                            name="firstName"
                            value={formData.firstName}
                            onChange={handleInputChange}
                            placeholder="Enter first name"
                        />
                    </div>
                    <div className="oms-form-group">
                        <label className="oms-form-label">Last Name</label>
                        <input
                            type="text"
                            name="lastName"
                            value={formData.lastName}
                            onChange={handleInputChange}
                            placeholder="Enter last name"
                        />
                    </div>

                    <div className="oms-form-group">
                        <label className="oms-form-label">Date of Birth</label>
                        <input
                            type="date"
                            name="dob"
                            value={formData.dob}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="oms-form-group">
                        <label className="oms-form-label">Gender</label>
                        <div className="oms-form-radio">
                            {["Male", "Female", "Other"].map((g) => (
                                <label
                                    key={g}
                                    className={`flex items-center gap-2 px-4 py-2 rounded-lg cursor-pointer border transition
      ${formData.gender === g
                                            ? "bg-blue-500 text-white border-blue-600 shadow-md"
                                            : "bg-white text-gray-700 border-gray-300 hover:border-blue-400"
                                        }`}
                                >
                                    <input
                                        type="radio"
                                        name="gender"
                                        value={g}
                                        checked={formData.gender === g}
                                        onChange={handleInputChange}
                                        className="hidden"
                                    />
                                    {g}
                                </label>
                            ))}

                        </div>
                    </div>
                    <div className="oms-form-group">
                        <label className="oms-form-label">Photo</label>
                        <input type="file" name="profilePic" onChange={handleFileChange} />







                        {console.log(prefill)}

                    </div>
                    {preview && (
                        <div className="mt-2">
                            <img
                                src={preview}
                                alt="Profile"
                                className="w-24 h-24 rounded-full object-cover"
                            />
                        </div>
                    )}
                </div>

                {/* ---------- Contact Information ---------- */}
                <h3 className="text-xl sm:text-2xl md:text-3xl font-semibold text-gray-800 border-b-2 border-blue-500 inline-block pb-1 tracking-wide">
                    Contact Information
                </h3>

                <div className="oms-form-flex">
                    <div className="oms-form-group">
                        <label className="oms-form-label">Address</label>
                        <textarea
                            name="address"
                            value={formData.address}
                            onChange={handleInputChange}
                            placeholder="Enter address"
                        />
                    </div>
                    <div className="oms-form-group">
                        <label className="oms-form-label">Phone</label>
                        <input
                            type="tel"
                            name="phone"
                            value={formData.phone}
                            onChange={handleInputChange}
                            placeholder="Enter phone number"
                        />
                    </div>
                    <div className="oms-form-group">
                        <label className="oms-form-label">Email</label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                            placeholder="Enter email"
                        />
                    </div>
                    <div className="oms-form-group">
                        <label className="oms-form-label">Password</label>
                        <input
                            type="password"
                            name="password"
                            value={formData.password}
                            onChange={handleInputChange}
                            placeholder="Enter password"
                        />
                    </div>
                    <div className="oms-form-group">
                        <label className="oms-form-label">Emergency Contact</label>
                        <input
                            type="tel"
                            name="emergency_contact_phone"
                            value={formData.emergency_contact_phone}
                            onChange={handleInputChange}
                            placeholder="Enter emergency contact"
                        />
                    </div>
                </div>

                {/* ---------- Employment Details ---------- */}
                <h3 className="text-xl sm:text-2xl md:text-3xl font-semibold text-gray-800 border-b-2 border-blue-500 inline-block pb-1 tracking-wide">Employment Details</h3>
                <div className="oms-form-flex">
                    <div className="oms-form-group">
                        <label className="oms-form-label">Job Title</label>
                        <input
                            type="text"
                            name="job_title"
                            value={formData.job_title}
                            onChange={handleInputChange}
                            placeholder="Enter job title"
                        />
                    </div>
                    <div className="oms-form-group">
                        <label className="oms-form-label">Department</label>
                        <Select
                            name="department"
                            value={
                                formData.department
                                    ? { value: formData.department, label: formData.department }
                                    : null
                            }
                            options={department
                                .filter((dep) => dep.status === "Active") // ✅ only active departments
                                .map((dep) => ({
                                    value: dep.department_name,
                                    label: dep.department_name
                                }))
                            }
                            onChange={(opt) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    department: opt?.value || "",
                                }))
                            }
                            isClearable
                        />
                    </div>


                    <div className="oms-form-group">
                        <label className="oms-form-label">Date of Joining</label>
                        <input
                            type="date"
                            name="dof_joining"
                            value={formData.dof_joining}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="oms-form-group">
                        <label className="oms-form-label">Employee Status</label>
                        <Select
                            name="status"
                            value={
                                formData.employ_status
                                    ? { value: formData.employ_status, label: formData.employ_status }
                                    : null
                            }
                            options={[
                                { value: "Active", label: "Active" },
                                { value: "Inactive", label: "Inactive" },
                                { value: "Probation", label: "Probation" },
                            ]}
                            onChange={(opt) =>
                                setFormData((prev) => ({ ...prev, employ_status: opt?.value || "" }))
                            }
                        />
                    </div>
                    <div className="oms-form-group">
                        <label className="oms-form-label">Reporting report_manager</label>
                        <input
                            type="text"
                            name="report_manager"
                            value={formData.report_manager}
                            onChange={handleInputChange}
                            placeholder="Enter report_manager"
                        />
                    </div>
                    <div className="oms-form-group">
                        <label className="oms-form-label">Office Location</label>
                        <input
                            type="text"
                            name="office_location"
                            value={formData.office_location}
                            onChange={handleInputChange}
                            placeholder="Enter office location"
                        />
                    </div>
                    <div className="oms-form-group">
                        <label className="oms-form-label">Working Hours</label>
                        <div className="flex items-center gap-1">
                            <div className="w-full">
                                <label htmlFor="start_time">Start Time</label>
                                <input
                                    type="time"
                                    name="start_time"
                                    value={formData.start_time}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="w-full">
                                <label htmlFor="end_time">End Time</label>
                                <input
                                    type="time"
                                    name="end_time"
                                    value={formData.end_time}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* ---------- Professional Info ---------- */}
                <h3 className="text-xl sm:text-2xl md:text-3xl font-semibold text-gray-800 border-b-2 border-blue-500 inline-block pb-1 tracking-wide">Professional Information</h3>
                <div className="oms-form-flex">
                    <div className="oms-form-group">
                        <label className="oms-form-label">qualifications</label>
                        <input
                            type="text"
                            name="qualifications"
                            value={formData.qualifications}
                            onChange={handleInputChange}
                            placeholder="Enter qualifications"
                        />
                    </div>
                    <div className="oms-form-group">
                        <label className="oms-form-label">Experience</label>
                        <input
                            type="text"
                            name="prev_exp"
                            value={formData.prev_exp}
                            onChange={handleInputChange}
                            placeholder="Enter previous experience"
                        />
                    </div>

                    <div className="oms-form-group">
                        <label className="oms-form-label">Skills</label>
                        <div className="oms-form-multi">
                            <input
                                type="text"
                                value={skillInput}
                                onChange={(e) => setSkillInput(e.target.value)}
                                onKeyDown={handleSkillKeyDown}
                                placeholder="Type and press comma"
                                className="flex-1 min-w-[120px] border-none focus:ring-0 text-gray-700 placeholder-gray-400"
                            />
                        </div>


                        {skills.map((skill, index) => (
                            <span
                                key={index}
                                className="inline-flex items-center flex-wrap gap-2 bg-blue-100 text-blue-700 text-sm px-3 py-1 rounded-full mt-1 mr-1"
                            >
                                <span>{skill}</span>
                                <span
                                    onClick={() => removeSkill(index)}
                                    className="text-blue-600 hover:text-red-600 focus:outline-none"
                                >
                                    <X size={14} />
                                </span>
                            </span>
                        ))}
                    </div>

                    {/* language_known */}
                    <div className="oms-form-group">
                        <label className="oms-form-label">language Known</label>
                        <div className="oms-form-multi">
                            <input
                                type="text"
                                value={languageInput}
                                onChange={(e) => setLanguageInput(e.target.value)}
                                onKeyDown={handleLanguageKeyDown}
                                placeholder="Type and press comma"
                                className="flex-1 min-w-[120px] border-none focus:ring-0 text-gray-700 placeholder-gray-400"
                            />
                        </div>
                        {language_known.map((lang, index) => (
                            <span
                                key={index}
                                className="inline-flex items-center flex-wrap gap-2 bg-blue-100 text-blue-700 text-sm px-3 py-1 rounded-full mt-1 mr-1"
                            >
                                <span>{lang}</span>
                                <span
                                    onClick={() => removeLanguage(index)}
                                    className="text-blue-600 hover:text-red-600 focus:outline-none"
                                >
                                    <X size={14} />
                                </span>
                            </span>
                        ))}
                    </div>
                </div>

                {/* ---------- Payroll Info ---------- */}
                <h3 className="text-xl sm:text-2xl md:text-3xl font-semibold text-gray-800 border-b-2 border-blue-500 inline-block pb-1 tracking-wide">Payroll Information</h3>
                <div className="oms-form-flex">
                    <div className="oms-form-group">
                        <label className="oms-form-label">Account No</label>
                        <input
                            type="text"
                            name="account_no"
                            value={formData.account_no}
                            onChange={handleInputChange}
                            placeholder="Enter account no"
                        />
                    </div>
                    <div className="oms-form-group">
                        <label className="oms-form-label">IFSC Code</label>
                        <input
                            type="text"
                            name="ifsc"
                            value={formData.ifsc}
                            onChange={handleInputChange}
                            placeholder="Enter IFSC"
                        />
                    </div>

                    <div className="oms-form-group">
                        <label className="oms-form-label">Bank Name</label>
                        <input
                            type="text"
                            name="bank"
                            value={formData.bank}
                            onChange={handleInputChange}
                            placeholder="Enter bank name"
                        />
                    </div>

                    <div className="oms-form-group">
                        <label className="oms-form-label">Provident Fund No</label>
                        <input
                            type="text"
                            name="pfNo"
                            value={formData.pfNo}
                            onChange={handleInputChange}
                            placeholder="Enter PF number"
                        />
                    </div>

                </div>

                {/* ---------- Other Info ---------- */}
                <h3 className="text-xl sm:text-2xl md:text-3xl font-semibold text-gray-800 border-b-2 border-blue-500 inline-block pb-1 tracking-wide">Other Information</h3>
                <div className="oms-form-flex">
                    <div className="oms-form-group">
                        <label className="oms-form-label">Marital Status</label>
                        <Select
                            name="marital_status"
                            value={
                                formData.marital_status
                                    ? { value: formData.marital_status, label: formData.marital_status }
                                    : null
                            }
                            options={[
                                { value: "Single", label: "Single" },
                                { value: "Married", label: "Married" },
                                { value: "Other", label: "Other" },
                            ]}
                            onChange={(opt) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    marital_status: opt?.value || "",
                                }))
                            }
                        />
                    </div>

                    {/* Hobbies Multi Add */}
                    {/* Hobbies */}
                    <div className="oms-form-group">
                        <label className="oms-form-label">Hobbies</label>
                        <div className="oms-form-multi">
                            <input
                                type="text"
                                value={hobbyInput}
                                onChange={(e) => setHobbyInput(e.target.value)}
                                onKeyDown={handleHobbyKeyDown}
                                placeholder="Type and press comma"
                                className="flex-1 min-w-[120px] border-none focus:ring-0 text-gray-700 placeholder-gray-400"
                            />
                        </div>
                        {hobbies_interest.map((hobby, index) => (
                            <span
                                key={index}
                                className="inline-flex items-center flex-wrap gap-2 bg-blue-100 text-blue-700 text-sm px-3 py-1 rounded-full mt-1 mr-1"
                            >
                                <span>{hobby}</span>
                                <span
                                    onClick={() => removeHobbies(index)}
                                    className="text-blue-600 hover:text-red-600 focus:outline-none"
                                >
                                    <X size={14} />
                                </span>
                            </span>
                        ))}
                    </div>

                    <div className="oms-form-group">
                        <label className="oms-form-label">Weekly Holiday</label>
                        <Select
                            isMulti
                            options={daysOptions}
                            value={selectedValues}
                            onChange={handleChange}
                            placeholder="Select weekly holidays"
                        />
                    </div>
                </div>

                {/* ---------- Submit ---------- */}
                {
                    loading ?<button type="button" className="oms-submit-btn">
                    Submiting...
                </button>:<button type="submit" className="oms-submit-btn">
                    Submit
                </button>
                }
                
            </form>
        </>
    );
};

export default NewStaff;
